import { Button, Container, FormControl, FormLabel, Input, Stack, Typography } from '@mui/joy';
import React, { useState } from 'react';
import { useLoaderData, useNavigate } from 'react-router';
import { serviceFacade } from '../services/service-facade';
import { recentRoundsService } from '../services/recent-rounds-service';
import { getMyIdentity } from '../services/player-identity-service';
import { Round } from '../models/round';

const JoinRound = () => {
    const { round } = useLoaderData() as { round: Round };
    const [playerName, setPlayerName] = useState(() => getMyIdentity()?.name ?? '');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleJoinRound = async () => {
        try {
            setIsLoading(true);
            const response = await serviceFacade.joinRound(round.id, playerName);
            const player = response.body.player;
            recentRoundsService.updateRecentRounds(
                round.id,
                round.name,
                round.date,
                player.id,
                player.name,
                round.expires_at
            );
            navigate(`/${round.id}/${player.id}`);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Container>
            <Stack spacing={4}>
                <Typography level="h2">Join Round</Typography>
                <Typography>{round.name}</Typography>
                <FormControl>
                    <FormLabel>Player Name</FormLabel>
                    <Input
                        placeholder="Enter your name"
                        value={playerName}
                        onChange={(e) => setPlayerName(e.target.value)}
                    />
                </FormControl>
                <Button onClick={handleJoinRound} loading={isLoading} disabled={!playerName.trim() || isLoading}>
                    Join Round
                </Button>
            </Stack>
        </Container>
    );
};

export default JoinRound;
